import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Select from 'flarum/common/components/Select';
import Stream from 'flarum/utils/Stream';
import LoadingIndicator from "flarum/components/LoadingIndicator";

export default class StatisticSidebarComponent extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.viewType = this.attrs.viewType;
    this.loading = true;
    this.moreResults = false;
    this.u2diStatisticList = [];
    this.loadUserResult();
  }

  view() {
    const mapModule = this.mapModule;
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');
    const u2diStatisticList = this.u2diStatisticList;
    const u2diStatisticData = u2diStatisticList[0];

    let loading;

    if (this.loading) {
      loading = LoadingIndicator.component({ size: "large" });
    }

    let sideBarContentContainierStyle = "min-height: 360px;height: calc(100vh - 300px)";

    return (
      <div>
        {this.viewType==="normal" && (
          <div className="u2diMapSideBarTitleContainier">
            <div className="u2diMapSideBarTitle">
              {app.translator.trans("ziven-u2di.forum.map-sidebar-statistic-title")}
            </div>

            <div style={sideBarContentContainierStyle} className="u2diMapSideBarContentContainier">
              {u2diStatisticList.length>0 && (
                <div>
                  <div style="padding:2px 10px 5px 10px" className="u2diMapSideBarInfoData u2diInfoItemContainer">
                    <div className="u2diStatisticHeader">
                      <div className="u2diStatisticLabel">概览</div>
                      <div style="font-weight:bold;font-size:12px;color:#7F7F7F">
                        <span>资产条数：</span><span style="color:#70B603;font-size:18px">{u2diStatisticData.totalInfoCount()}</span> <span>宗</span>
                      </div>
                    </div>

                    <div className="u2diStatisticCardContent">
                      <div style="color:var(--text-color);margin-top: 2px;">土地：</div>
                      <div>
                        <div>
                          <span style="color:#C99C5B;font-size: 14px;">{u2diStatisticData.totalInfoTDWZCount()}</span> <span>宗</span>，<span>面积 </span><span style="color:#C99C5B;font-size: 14px;">{Math.round(u2diStatisticData.totalInfoTDWZSum()*100)/100}</span> <span>亩</span>
                        </div>
                        <div style="margin-top: 2px;">
                          <span>成交 </span><span style="color:#D9001B;font-size: 14px;">{Math.round(u2diStatisticData.totalInfoTDWZCompletedSum()*100)/100}</span> <span>亩（{u2diStatisticData.totalInfoTDWZCompletedCount()}宗）</span>
                        </div>
                      </div>
                    </div>

                    <div style="padding-top: 2px;" className="u2diStatisticCardContent">
                      <div style="color:var(--text-color);margin-top: 2px;">建筑：</div>
                      <div>
                        <div>
                          <span style="color:#C99C5B;font-size: 14px;">{u2diStatisticData.totalInfoJZWZCount()}</span> <span>宗</span>，<span>面积 </span><span style="color:#C99C5B;font-size: 14px;">{Math.round(u2diStatisticData.totalInfoJZWZSum())}</span> <span>m²</span>
                        </div>
                        <div style="margin-top: 2px;">
                          <span>成交 </span><span style="color:#D9001B;font-size: 14px;">{Math.round(u2diStatisticData.totalInfoJZWZCompletedSum())}</span> <span>m²（{u2diStatisticData.totalInfoJZWZCompletedCount()}宗）</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="margin-top:10px;padding:2px 10px 5px 10px" className="u2diMapSideBarInfoData u2diInfoItemContainer">
                    <div className="u2diStatisticHeader">
                      <div className="u2diStatisticLabel">询地</div>
                      <div style="font-weight:bold;font-size:12px;color:#7F7F7F">
                        <span>询地次数：</span><span style="color:#70B603;font-size:18px">{u2diStatisticData.totalQueryCount()}</span> <span>次</span>
                      </div>
                    </div>

                    <div className="u2diStatisticCardContent">
                      <div style="color:var(--text-color);margin-top: 2px;">待处理：</div>
                      <div>
                        <span style="font-size:14px;color:#D9001B">{u2diStatisticData.totalQueryProcessingCount()}</span> 次，
                        已处理：<span style="font-size:14px;color:#C99C5B">{u2diStatisticData.totalQueryCompletedCount()}</span> 次
                      </div>
                    </div>
                  </div>

                  <div style="margin-top:10px;padding:2px 10px 5px 10px" className="u2diMapSideBarInfoData u2diInfoItemContainer">
                    <div className="u2diStatisticHeader">
                      <div className="u2diStatisticLabel">用户</div>
                      <div style="font-weight:bold;font-size:12px;color:#7F7F7F">
                        <span>用户总数：</span><span style="color:#70B603;font-size:18px">{u2diStatisticData.totalUserCount()}</span> <span>名</span>
                      </div>
                    </div>

                    <div style="display:block" className="u2diStatisticCardContent">
                      <div style="display:flex">
                        <div style="color:var(--text-color);margin-top: 2px;">正常：</div>
                        <div>
                          <span style="font-size:14px;color:#70B603">{u2diStatisticData.totalUserNormalCount()}</span> 名
                        </div>
                      </div>
                      <div style="display:flex">
                        <div style="color:var(--text-color);margin-top: 2px;">暂停：</div>
                        <div style="width:60px">
                          <span style="font-size:14px;color:#C99C5B">{u2diStatisticData.totalUserExpiredCount()}</span> 名
                        </div>
                        <div style="color:var(--text-color);margin-top: 2px;">三个月内到期：</div>
                        <div>
                          <span style="font-size:14px;color:#C99C5B">{u2diStatisticData.totalUserThreeMonthExpireCount()}</span> 名
                        </div>
                      </div>
                      <div style="display:flex">
                        <div style="color:var(--text-color);margin-top: 2px;">封禁：</div>
                        <div style="width:60px">
                          <span style="font-size:14px;color:#D9001B">{u2diStatisticData.totalUserBannedCount()}</span> 名
                        </div>
                        <div style="color:var(--text-color);margin-top: 2px;">三个月内续期：</div>
                        <div>
                          <span style="font-size:14px;color:#C99C5B">{u2diStatisticData.totalUserThreeMonthExtendCount()}</span> 名
                        </div>
                      </div>
                      <div style="display:flex">
                        <div style="color:var(--text-color);margin-top: 2px;">长期：</div>
                        <div style="width:60px">
                          <span style="font-size:14px;color:#D9001B">{u2diStatisticData.totalUserNoExpirationCount()}</span> 名
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="margin-top:10px;padding:2px 10px 5px 10px" className="u2diMapSideBarInfoData u2diInfoItemContainer">
                    <div className="u2diStatisticHeader">
                      <div className="u2diStatisticLabel">其他</div>
                      <div style="text-align: right;">
                        <div style="font-weight:bold;font-size:12px;color:#7F7F7F">
                          <span>访问：</span><span style="color:#70B603">{u2diStatisticData.totalViewsCount()}</span><span>次</span>
                        </div>
                        <div style="font-weight:bold;font-size:12px;color:#7F7F7F">
                          <span>分销：</span><span style="color:#70B603">{u2diStatisticData.totalDistributeCount()}</span><span>次</span>，公告：<span style="color:#70B603">{u2diStatisticData.totalAnnouncementCount()}</span>条
                        </div>
                      </div>
                    </div>

                    <div className="u2diStatisticCardContent">
                      <div style="color:var(--text-color);margin-top: 2px;">宗均优客分销次数：</div>
                      <div>
                        <span style="font-size:14px;color:#C99C5B">{u2diStatisticData.totalDistributePerInfo()}</span> 次/宗
                      </div>
                    </div>

                    <div style="margin-top: -15px;" className="u2diStatisticCardContent">
                      <div style="color:var(--text-color);margin-top: 2px;">宗均卡片访问次数：</div>
                      <div>
                        <span style="font-size:14px;color:#C99C5B">{u2diStatisticData.totalViewPerInfo()}</span> 次/宗
                      </div>
                    </div>
                  </div>

                </div>
              )}

              {loading && <div className="u2di-loadMore">{loading}</div>}
            </div>
          </div>
        )}

      </div>
    );
  }

  parseResults(results) {
    this.moreResults = !!results.payload.links && !!results.payload.links.next;
    [].push.apply(this.u2diStatisticList, results);
    this.loading = false;
    m.redraw();

    return results;
  }

  loadUserResult(){
    app.store
      .find("u2diStatistic")
      .catch(() => {})
      .then(this.parseResults.bind(this));
  }
}